import React, {useEffect, useState} from "react";
import "../SettingsPage.scss";
import {InputField} from "../../../components/input-field/InputField";
import {api, useFetch} from "../../../hooks/useFetch";

const AccountInformation = () => {
	const user = JSON.parse(localStorage.getItem("user") || "{}");
	const {data: response, isLoading, error, mutate} = useFetch(`accounts/${user.accountId}`);

	const [accountName, setAccountName] = useState("");
	const [emailAddress, setEmailAddress] = useState("");
	const [website, setWebsite] = useState("");
	const [details, setDetails] = useState("");

	useEffect(() => {
		if (response) {
			setAccountName(response.name || "");
			setEmailAddress(response.email || "");
			setWebsite(response.website || "");
			setDetails(response.details || "");
		}
	}, [response]);

	const handleSaveDetails = async () => {
		try {
			await api.put(`accounts/${user.accountId}`, {
				name: accountName,
				email: emailAddress,
				website,
				details,
			});
			mutate();
		} catch (err) {
			console.error("Error updating account:", err);
		}
	};

	if (isLoading) return <p>Loading account information...</p>;
	if (error) return <p className="error">Failed to load account data.</p>;

	return (
		<div className="account-information-section">
			<div className="basic-information">
				<h2 className="basic-information-title">Basic Information</h2>
				<p className="basic-information-description">
					It is a long established fact that the reader...
				</p>
			</div>

			<div className="form-group">
				<InputField
					label="Account name"
					type="text"
					id="accountName"
					className="user-form__input"
					value={accountName}
					placeholder="Account name"
					onChange={(e) => setAccountName(e.target.value)}
				/>
			</div>

			<div className="form-row">
				<div className="form-group">
					<InputField
						label="Email address"
						type="email"
						id="emailAddress"
						className="user-form__input"
						value={emailAddress}
						placeholder="Email address"
						onChange={(e) => setEmailAddress(e.target.value)}
					/>
				</div>

				<div className="form-group">
					<InputField
						label="Website"
						type="text"
						id="website"
						className="user-form__input"
						value={website}
						placeholder="Website"
						onChange={(e) => setWebsite(e.target.value)}
					/>
				</div>
			</div>

			<div className="form-group">
				<label htmlFor="details">Details</label>
				<textarea
					id="details"
					rows="4"
					value={details}
					onChange={(e) => setDetails(e.target.value)}/>
			</div>

			<button className="save-details-button" onClick={handleSaveDetails}>
				Save Details
			</button>
		</div>
	);
};

export default AccountInformation;
